import axios from "axios";
import jwtDecode from "jwt-decode";
import * as configuration from "./configuration";
import storageAvailable from "./storageAvailable";
import store from '../store'
import appBridge from "./appBridge";
const initialConfig = {};
const httpClient = axios.create(initialConfig);

const authInterceptor = config => {
  return config;
};

const loggerInterceptor = config => {
  return config;
};

/** Adding the request interceptors */
httpClient.interceptors.request.use(authInterceptor);
httpClient.interceptors.request.use(loggerInterceptor);

/** Adding the response interceptors */
httpClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const token = store.state.store;
    
    if (error) {
      if (error.response) {
        console.log('herp', error.response);
        if (error.response.status === 403 && token.enfonicaAccessToken) {
          appBridge(token).redirectTo(
            token.onlineShopUrl +
            "admin/apps/" +
            configuration.APP_NAME +
            "?refresh=true"
          );
        }
        if (error.response.status === 401 && token.enfonicaAccessToken) {
          appBridge(token).redirectTo(
            token.onlineShopUrl +
            "admin/apps/" +
            configuration.APP_NAME +
            "?refresh=true"
          );

        }
        if (error.response.headers['grpc-message'] && error.response.headers['grpc-status']) {
          return Promise.reject({
            error,
            code: error.response.headers['grpc-status'],
            message: error.response.headers['grpc-message'],
            details: []
          });
        } else {
          return Promise.reject({
            error,
            ...error.response.data
          });
        }
      }
      console.log('no response object', error);
      return Promise.reject(error);
    }
  }
);

export { httpClient };
